import React from 'react'

import Styles from "./adminDecors.module.scss";
import { Table, Button, Input, Form, FormGroup, Label, Container } from 'reactstrap';
import { Editor } from '@tinymce/tinymce-react';
import confirm from 'reactstrap-confirm';
import IDecors from 'model/decor';
import decorsService from 'services/decorsService';
import IFileInfo from 'model/fileInfo';
import { isPicture } from 'components/common/fileExplorer/fileExplorer';
import FileFolderSelector from 'components/common/fileFolderSelector/fileFolderSelector';
interface IAdminDecorsProps {

}

interface IAdminDecorsState {
    decorEdition?: IDecors;
    decors: IDecors[];
    folders: IFileInfo[]
}

class AdminDecors extends React.Component<IAdminDecorsProps, IAdminDecorsState> {
    /**
     *
     */
    constructor(props: IAdminDecorsProps) {
        super(props);

        this.state = { decorEdition: undefined, decors: [], folders: [] };
    }


    componentDidMount() {
        this.load();
    }

    load() {
        Promise.all(
            [
                decorsService.GetAllDecors(),
                decorsService.GetPictureFolder()
            ]
        )
            .then(value => {
                this.setState({ decors: value[0].sort((a: IDecors, b: IDecors) => { return a.Id < b.Id ? -1 : 1 }), decorEdition: undefined, folders: value[1] });
            })
    }

    setdecorToEdit(decor: IDecors) {
        this.setState({ decorEdition: decor });
    }

    savedecor(decor: IDecors) {
        decorsService.SetDecor(decor).then(this.load.bind(this));
    }


    setdecorToDelete(decor: IDecors) {
        confirm({
            title: 'Suppression du decor',
            message: "Etes vous sûr de vouloir supprimer le decor ?",
            confirmText: "Supprimer",
            confirmColor: "primary",
            cancelColor: "danger"
        }).then((res: any) => {
            if (res) {
                return decorsService.DeleteDecor(decor).then(this.load.bind(this));
            }
        });
    }

    render() {
        return <div className={Styles.AdminDecors}>
            <Container>

                <Button color="primary" onClick={this.setdecorToEdit.bind(this, {} as IDecors)}>Créer un decor</Button>
                <Table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Titre</th>
                            <th>Editer</th>
                            <th>Supprimer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.decors.map(s => {
                            return <tr key={s.Id} className={Styles.decorRow}>
                                <th scope="row">{s.Id}</th>
                                <td>{s.Title}</td>
                                <td><Button color="primary" onClick={this.setdecorToEdit.bind(this, s)}>Editer</Button></td>
                                <td><Button color="danger" onClick={this.setdecorToDelete.bind(this, s)}>Supprimer</Button></td>
                            </tr>
                        })}
                    </tbody>

                </Table>
                {this.state.decorEdition ?

                    <div className={Styles.Edition}>
                        {this.state.decorEdition.Id ? <h2>Edition du decor {this.state.decorEdition.Id}</h2> : <h2>Création de decors</h2>}
                        <Form>
                            <FormGroup>
                                <Label for="inputTitle">Titre</Label>
                                <Input id="inputTitle" placeholder="Titre" value={this.state.decorEdition.Title} onChange={(newText) => {
                                    if (this.state.decorEdition)
                                        this.setState({ decorEdition: { ...this.state.decorEdition, Title: newText.target.value } })
                                }} />
                            </FormGroup>

                            <FormGroup>
                                <Label for="inputContent">Contenu</Label>
                                <div className="form-control" style={{ height: "auto" }}>
                                    <Editor id="inputContent" apiKey="9g0ulblxwkd76vrrs111j7ayxpx4tqqhkj1ai4nusl44j1zg"
                                        initialValue={this.state.decorEdition.Content}
                                        inline={true}
                                        onChange={(newText) => {
                                            if (this.state.decorEdition)
                                                this.setState({ decorEdition: { ...this.state.decorEdition, Content: newText.target.getContentAreaContainer().innerHTML } })
                                        }}
                                        init={{
                                            plugins: 'print preview fullpage powerpaste searchreplace autolink directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount tinymcespellchecker a11ychecker imagetools textpattern help formatpainter permanentpen pageembed mentions linkchecker',
                                            toolbar: 'formatselect | bold italic strikethrough underline forecolor backcolor permanentpen formatpainter | link image media pageembed | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat | addcomment',
                                            image_advtab: true,
                                            language: 'fr_FR',
                                            spellchecker_language: 'fr_FR'
                                        }} />
                                </div>

                            </FormGroup>
                            <FormGroup>
                                <Label for="inputPictureUrl">Image principale</Label>
                                <FileFolderSelector filter={isPicture} onSelect={this.saveChangeMainPicture.bind(this)} value={this.state.decorEdition.MainPictureUrl} />
                            </FormGroup>
                            <FormGroup>
                                <Label for="inputPictureFolder">Dossier d'images</Label>
                                <FileFolderSelector folder onSelect={this.saveChangeFolder.bind(this)} value={this.state.decorEdition.PictureFolder} />
                            </FormGroup>
                        </Form>
                        <Button color="primary" onClick={this.savedecor.bind(this, this.state.decorEdition)}>Sauvegarder</Button>
                        <Button color="danger" onClick={() => this.setState({ decorEdition: undefined })}>Annuler</Button>
                    </div>
                    : null
                }
            </Container>
        </div>
    }

    saveChangeFolder(value: string) {
        if (this.state.decorEdition)
            this.setState({ decorEdition: { ...this.state.decorEdition, PictureFolder: value } });
    }


    saveChangeMainPicture(value: string) {
        if (this.state.decorEdition)
            this.setState({ decorEdition: { ...this.state.decorEdition, MainPictureUrl: value } });
    }
}

export default AdminDecors;